module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('entity-page', {
    attrs: {
      "id": "page__forward-price",
      "loading": _vm.progress
    }
  }, [_c('template', {
    slot: "header-right"
  }, [_c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'xmark'],
      "danger-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'check'],
      "success-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.save
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Тип пункта экспедирования",
      "required": true,
      "name": "by",
      "id": "by",
      "data-vv-as": ' ',
      "error": _vm.errors.first('by')
    },
    on: {
      "input": _vm.resetType
    },
    model: {
      value: (_vm.price.by),
      callback: function($$v) {
        _vm.$set(_vm.price, "by", $$v)
      },
      expression: "price.by"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v(" Выбрать... ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "city"
    }
  }, [_vm._v(" Населённый пункт ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "steet"
    }
  }, [_vm._v(" Улица ")])]), _vm._v(" "), _c('z-input-autocomplete', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "property": "id",
      "return": "id",
      "label": "Населённый пункт (город/посёлок/село/...)",
      "display-property": "label",
      "name": "city_id",
      "callback": _vm.getCities,
      "default": (_vm.price.city && _vm.price.city.value) ? _vm.price.city.value : '',
      "id": "street",
      "error": _vm.errors.first('city_id'),
      "data-vv-name": "city_id",
      "data-vv-as": ' '
    },
    on: {
      "select": _vm.selectCity
    },
    model: {
      value: (_vm.price.city_id),
      callback: function($$v) {
        _vm.$set(_vm.price, "city_id", $$v)
      },
      expression: "price.city_id"
    }
  }), _vm._v(" "), (_vm.price.by == 'steet') ? _c('z-input-autocomplete', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "property": "value",
      "return": "id",
      "label": "Улица",
      "display-property": "label",
      "name": "street",
      "id": "street",
      "callback": _vm.getStreets,
      "default": (_vm.price.steet && _vm.price.steet.name) ? _vm.price.steet.name : '',
      "error": _vm.errors.first('street'),
      "data-vv-name": "street",
      "data-vv-as": ' '
    },
    on: {
      "select": _vm.selectSteet
    },
    model: {
      value: (_vm.price.street),
      callback: function($$v) {
        _vm.$set(_vm.price, "street", $$v)
      },
      expression: "price.street"
    }
  }) : _vm._e(), _vm._v(" "), _c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Тип расчёта",
      "required": true,
      "name": "type",
      "id": "type",
      "data-vv-as": ' ',
      "error": _vm.errors.first('type')
    },
    model: {
      value: (_vm.price.type),
      callback: function($$v) {
        _vm.$set(_vm.price, "type", $$v)
      },
      expression: "price.type"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v(" Выбрать... ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v(" По весу ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v(" По объёму ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': true,
        min_value: 0.001,
        max_value: 9999999999,
        decimal: [3, '.']
      }),
      expression: "{'required': true, min_value: 0.001, max_value: 9999999999, decimal: [3, '.']}"
    }],
    staticClass: "col-4",
    attrs: {
      "label": (parseInt(_vm.price.type) == 1) ? 'Минимальный вес' : 'Минимальный объём',
      "name": "value_min",
      "id": "value_min",
      "data-vv-name": "value_min",
      "data-vv-as": ' ',
      "required": true,
      "error": _vm.errors.first('value_min'),
      "type": "number"
    },
    model: {
      value: (_vm.price.value_min),
      callback: function($$v) {
        _vm.$set(_vm.price, "value_min", $$v)
      },
      expression: "price.value_min"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': true,
        min_value: 0.001,
        max_value: 9999999999,
        decimal: [3, '.']
      }),
      expression: "{'required': true, min_value: 0.001, max_value: 9999999999, decimal: [3, '.']}"
    }],
    staticClass: "col-4",
    attrs: {
      "label": (parseInt(_vm.price.type) == 1) ? 'Максимальный вес' : 'Максимальный объём',
      "name": "value_max",
      "id": "value_max",
      "data-vv-name": "value_max",
      "data-vv-as": ' ',
      "required": true,
      "error": _vm.errors.first('value_max'),
      "type": "number"
    },
    model: {
      value: (_vm.price.value_max),
      callback: function($$v) {
        _vm.$set(_vm.price, "value_max", $$v)
      },
      expression: "price.value_max"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': true,
        min_value: 0.01,
        max_value: 9999999999,
        decimal: [2, '.']
      }),
      expression: "{'required': true, min_value: 0.01, max_value: 9999999999, decimal: [2, '.']}"
    }],
    staticClass: "col-4",
    attrs: {
      "label": "Стоимость",
      "name": "price",
      "id": "price",
      "data-vv-name": "price",
      "data-vv-as": ' ',
      "required": true,
      "error": _vm.errors.first('price'),
      "type": "number"
    },
    model: {
      value: (_vm.price.price),
      callback: function($$v) {
        _vm.$set(_vm.price, "price", $$v)
      },
      expression: "price.price"
    }
  })], 1)], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef6fffd0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/cost/views/ForwardingPrice.vue
// module id = 1276
// module chunks = 0